// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"42b7fb1e","602":"6da97979","670":"e627f50e","770":"7471b9e9","918":"fb9de67b","951":"030c6c21","972":"a60eb359"}[chunkId] + ".chunk.css";
};